import React from 'react';

import { PaymentMethodType } from 'src/legacy/components/AddPaymentMethod/ChoosePaymentMethodSetup';
import { ModalWrapper, ModalWrapperProps } from 'src/legacy/components/Modals';
import BaseTypography from 'src/legacy/components/Text/BaseTypography';
import {
  ChoosePaymentMethod,
  ChoosePaymentMethodProps,
} from 'src/routes/billing/invoices/components/InvoiceEditPage/ChoosePaymentMethod';
import { PaymentOptions } from 'src/services/api/invoicesApi';
import * as Colors from 'src/theme/colors';

export type ChoosePaymentMethodOptions = Omit<
  ChoosePaymentMethodProps,
  'onPaymentMethodSelected'
>;
interface AddPaymentMethodModalProps {
  modalProps: ModalWrapperProps;
  paymentOptions: PaymentOptions;
  onPaymentMethodSelected: (paymentMethod: PaymentMethodType) => void;
  amountDue: number;
  currency: string;
}

export const AddPaymentMethodModal: React.FC<AddPaymentMethodModalProps> = ({
  modalProps,
  paymentOptions,
  onPaymentMethodSelected,
  amountDue,
  currency,
}) => (
  <ModalWrapper
    title="Connect payment method"
    hideActions
    width={500}
    {...modalProps}
    disableEnforceFocus
  >
    <div>
      <BaseTypography style={{ color: Colors.GraySmall }}>
        Select a payment method type you want to add.
      </BaseTypography>
      <ChoosePaymentMethod
        paymentOptions={paymentOptions}
        onPaymentMethodSelected={onPaymentMethodSelected}
        amountDue={amountDue}
        currency={currency}
      />
    </div>
  </ModalWrapper>
);
